/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

const SERVICES = {
    RULERLESS: "Rulerless",
    RULERLESS_IOS: "Rulerless_iOS",
    RULERLESS_IOS_OFFLINE: "Rulerless_iOS_Offline",
    RULERLESS_TRUCK_BAGGAGE: "Rulerless_Truck_Baggage"
}

export const SERVICES_DESCRIPTION = {
    [SERVICES.RULERLESS]: 'Rulerless Web',
    [SERVICES.RULERLESS_IOS]: 'Rulerless iOS',
    [SERVICES.RULERLESS_IOS_OFFLINE]: 'Rulerless iOS(Offline)',
    [SERVICES.RULERLESS_TRUCK_BAGGAGE]: 'Rulerless 積載率機能追加',
}

export default SERVICES